import React, { Suspense, useMemo } from "react";
import DashboardCard from "@/features/dashboard/components/dashboard-card";
import TrendingBrandsGrid from "@/features/dashboard/features/trending-brand-section/components/trending-brands-grid";
import TrendingBrandsHeader from "@/features/dashboard/features/trending-brand-section/components/trending-brands-header";
import usePersistedLineSheetSetListQuery from "@/features/dashboard/features/trending-brand-section/hooks/useTrendingBrandsQuery";
import DashboardCardSpinner from "@/features/dashboard/components/dashboard-card-spinner";
import useIdentity from "@/features/ui/hooks/use-identity";

export default function TrendingBrandSection() {
  const {
    value: query,
    set: setQuery,
    clear,
  } = usePersistedLineSheetSetListQuery();
  const identity = useIdentity();

  const trendingBrandsQuery = useMemo(
    () => ({
      by: query.by,
      period: query.period,
      buyer_id: identity?.company?.id!
    }),
    [query.by, query.period, identity?.company?.id],
  );

  return (
    <DashboardCard>
      <DashboardCard.Header>
        <TrendingBrandsHeader query={query} setQuery={setQuery} clear={clear} />
      </DashboardCard.Header>
      <DashboardCard.Body isScrollable={true}>
        <Suspense fallback={<DashboardCardSpinner />}>
          <TrendingBrandsGrid query={trendingBrandsQuery} />
        </Suspense>
      </DashboardCard.Body>
    </DashboardCard>
  );
}
